import { useFeatureFlags } from "apps/wrapper/src/hooks/feature-flags/use-feature-flags";
import { useAlerts } from "apps/wrapper/src/hooks/use-alerts";
import { Location } from "apps/wrapper/src/services/api-client/voice-api";

export const LocationItem = ({ option, unreadCount, ...rest }: { option: Location; unreadCount?: number, index: number }) => {
  const { hasFeature } = useFeatureFlags();
  const hasMessenger = hasFeature(option.id, 'messenger2')
  const { alertsActive } = useAlerts();
  const locationAlerts = alertsActive.filter((d) => d.idLocation === option?.id).length;

  return (
    <li {...rest}>
      <div className="location-name" title={option?.name}>
        {option?.name}
      </div>
      <div className="location-info">
        {hasMessenger && (
          <>
            Unread: <b>{unreadCount || 0}</b>
          </>
        )}
        {hasMessenger && <span className="separator" />}
        Alerts: <b>{locationAlerts}</b>
      </div>
      <hr />
    </li>
  );
}
